import { sortByIgst,sortByCgst,customSortInvoiceDate,customSortInvoiceNo,customSortTotalAmount,sortBySgst,sortByBaseAmount,customSortDate,genericSort } from "views/admin/embrillTable/customSort/customSort";

export const gstRecordColumns = [
    {
      Header: "No",
      accessor: "no",
    },
    {
      Header: "In No",
      accessor: "inNo",
      sortType:customSortInvoiceNo
    },
    {
      Header: "Invoice Date",
      accessor: "invoiceDate",
      sortType:customSortInvoiceDate
    },
    {
      Header: "Client Name",
      accessor: "client",
      sortType:genericSort
    },
    {
      Header: "GST Number",
      accessor: "gstNumber",
    },
    {
      Header: "Base Amount",
      accessor: "baseAmount",
      sortType:sortByBaseAmount
    },
    {
      Header: "IGST Amount",
      accessor: "igstAmt",
      sortType:sortByIgst
  
    },
    {
      Header: "SGST Amount",
      accessor: "sgstAmt",
      sortType:sortBySgst
    },
    {
      Header: "CGST Amount",
      accessor: "cgstAmt",
      sortType:sortByCgst
  
    },
    {
      Header: "Total GST",
      accessor: "totalGst",
      sortType:customSortTotalAmount
    },
    
    
  ];

  export const tdsRecordColumns = [
    {
      Header: "No",
      accessor: "no",
    },
    {
      Header: "In No",
      accessor: "inNo",
      sortType:customSortInvoiceNo
    },
    {
      Header: "Invoice Date",
      accessor: "invoiceDate",
      sortType:customSortInvoiceDate
    },
    {
      Header: "Client Name",
      accessor: "client",
      sortType:genericSort
    },
    {
      Header: "Base Amount",
      accessor: "baseAmount",
      sortType:sortByBaseAmount
    },
    {
      Header: "Percentage",
      accessor: "percentage",
    },
    {
      Header: "Tds Amount",
      accessor: "tdsAmount",
      sortType:sortByIgst
  
    },    
    
  ];


  export const paymentRecordColumns = [
    {
      Header: "No",
      accessor: "no",
    },
    {
      Header: "In No",
      accessor: "inNo",
      sortType:customSortInvoiceNo
    },
    {
      Header: "Client Name",
      accessor: "client",
      sortType:genericSort
    },
    {
      Header: "Payment Date",
      accessor: "date",
      sortType:customSortDate
    },
    {
      Header: "Payment ID",
      accessor: "paymentId"
    },
    {
      Header: "Referance No",
      accessor: "referanceNo",
      sortType:sortByBaseAmount
    }, 
    {
      Header: "Payment Mode",
      accessor: "paymentMode",
      sortType:genericSort

    },
    {
      Header: "Bank Charge",
      accessor: "bankCharge",
      sortType:sortByBaseAmount
    },
    {
      Header: "Amount",
      accessor: "amount",
      sortType:sortByBaseAmount
    },
  ];